// extracted by mini-css-extract-plugin
export default {"person":"Person_person__-wQ5h","personHeader":"Person_personHeader__08UZ+","personFilter":"Person_personFilter__xtUI3"};